AuthRoute = require 'mixins/authenticated-route'

App.DashboardRoute = Em.Route.extend AuthRoute,
  loadDynamics: (organization, range) ->
    organization.statsDynamics({ range })
    .then (data) =>
      if range in [ 'month', 'week' ]
        data.orders_dynamics.values = data.orders_dynamics.values[0...-1]

      data

  loadStatForRange: (range) ->
    organization = @get('session').get('currentOrganization')

    Em.RSVP.hash
      dynamics: @loadDynamics(organization, range)
      clients: organization.statsClients({range})

  model: (params) ->
    organization = @get('session').get('currentOrganization')

    Em.RSVP.all([
      @loadStatForRange(params.range),
      organization.checklist()
    ])

  setupController: (controller, model) ->
    checklistPayload = model[1]

    controller.set('dynamicsStatData',  model[0].dynamics)
    controller.set('clientsStatData',   model[0].clients)
    controller.set('checklistData',     checklistPayload.checklist)
    controller.set('hasZeroData',       checklistPayload.has_zero_data_stat)

    controller.loadBasketStats()

  actions:
    didTransition: ->
      @controllerFor('dashboard').set('transitionComplete', true)
      false

    fetchDynamics: (range) ->
      controller = @controllerFor('dashboard')
      return if controller.get('isDynamicsLoading')

      controller.set('isDynamicsLoading', true)
      @loadStatForRange(range)
      .then (data) =>
        controller.set('dynamicsStatData', data.dynamics)
        controller.set('basketsStatData',  data.baskets)
      .finally =>
        controller.set('isDynamicsLoading', false)
      false

